import { IAuctionStatusNotificationProps } from '../../../types/auction';

export function showNotification(detail: IAuctionStatusNotificationProps) {
  const event = new CustomEvent('auctionNotificationShow', { detail });

  document.dispatchEvent(event);
}
